import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { RootState } from "../../store";
import { config } from "../../Constants";
import { 
    updateState, 
    toggleFollowUpEmailDeletePrompt
} from "../../store/emails/emailReducer";
import { FETCH_FOLLOW_UP_EMAIL_DATA } from "../../store/emails/constants";
import { getAuthTokenConfig } from "../../helpers/others/getAuthTokenConfig";
import { handleApiError } from "../../helpers/error-handlers/handleApiError";
import DeletePrompt from "../../components/common/prompts/DeletePrompt";

const DeleteFollowUpEmail = () => {

    const dispatch = useDispatch();
    const emailState = useSelector((state: RootState) => state.emailState);
    const { followUpEmailItemInAction } = emailState;

    const closeDeletePrompt = () => {
        dispatch(toggleFollowUpEmailDeletePrompt(null))
    }

    const deleteProduct = async() => {

        const endpoint = config.url.BACKEND_API_URL + "/emails/followup-emails/delete/" + followUpEmailItemInAction?._id;
        const authConfig = getAuthTokenConfig();

        dispatch(toggleFollowUpEmailDeletePrompt(null));

        dispatch(updateState({
            name: "actionMessage",
            value: "Deleting..."
        }));

        try {

            const response = await axios.delete(endpoint, authConfig);

            dispatch(updateState({
                name: "actionMessage",
                value: response.data
            }));

            dispatch({ type: FETCH_FOLLOW_UP_EMAIL_DATA })

        } catch(error) {
            const { message } = handleApiError(error);
            dispatch(updateState({
                name: "actionMessage",
                value: message
            }));
        }

    }
    
    return (
        <DeletePrompt 
            warningText={<p>Are you sure want to delete <span>{followUpEmailItemInAction?.title}</span></p>}
            closeDeletePrompt={closeDeletePrompt}
            deleteItem={deleteProduct}
        />
    );

}

export default DeleteFollowUpEmail;